<div
  class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2 sp-table__sticky-header">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'STORES.CARDS_LABEL' | translate }}</h3>
    </div>
  </div>

  <div
    class="sp-width__full sp-margin__top-x2 sp-overflow__y-scroll sp-padding__right-x2"
    style="max-height: 140px">
    <div class="sp-buyer-details-general-card__grid">
      <div
        *ngFor="let payment_source of payment_sources; let i = index"
        class="sp-payment-sources-data-list__item sp-cursor__pointer">
        <div class="sp-background__primary-light sp-padding sp-border-radius__s sp-card-container">
          <div class="sp-row__align">
            <mat-icon> credit_card </mat-icon>
            <p class="sp-margin__left">{{ payment_source?.stripe_card?.funding || '-' }}</p>
            <p class="sp-margin__left-x12">
              {{ payment_source?.stripe_card?.exp_month || '-' }} / {{ payment_source?.stripe_card?.exp_year }}
            </p>
          </div>

          <h2 class="sp-text__center sp-margin__top sp-margin__auto">**** {{ payment_source?.stripe_card?.last4 }}</h2>

          <div class="sp-row__end sp-padding__top">
            <img
              *ngIf="getCardLogo(payment_source?.stripe_card?.brand || '-')"
              class="sp-table__payment_methods_icon"
              [src]="getCardLogo(payment_source?.stripe_card?.brand || '-')" />

            <button
              mat-icon-button
              class="sp-icon__button sp-icon__button-accent"
              [matTooltip]="'GENERAL.DELETE_CTA' | translate"
              (click)="onDeleteCardClick(); $event.stopPropagation()">
              <mat-icon class="material-symbols-outlined"> delete </mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
